import Heading from "./widgets/Heading";
import Paragraph from "./widgets/Paragraph";
import TextInput from "./widgets/TextInput";
import TextLabel from "./widgets/TextLabel";
import Url from "./widgets/Url";

const widgets = {
  hidden: {
    component: () => <></>,
    options: {},
    priority: 0, // ! 0 - 9
  },
  textLabel: {
    component: TextLabel,
    options: {
      hideKeys: {
        type: "boolean",
        default: false,
      },
      color: {
        type: "string",
        default: "inherit",
      },
      // ... CSS styles
    },
    priority: 1,
  },
  textInput: {
    component: TextInput,
    options: {
      hideKeys: {
        type: "boolean",
        default: false,
      },
      type: {
        type: "string",
        default: "text",
      },
    },
    priority: 1,
  },
  textarea: {
    component: () => <></>,
    options: {
      hideKeys: {
        type: "boolean",
        default: false,
      },
    },
    priority: 1,
  },
  text: {
    component: Paragraph,
    options: {
      hideKeys: {
        type: "boolean",
        default: false,
      },
    },
    priority: 1,
  },
  heading: {
    component: Heading,
    options: {
      hideKeys: {
        type: "boolean",
        default: true,
      },
      level: {
        type: "number",
        default: 1, // 1 - 3
      },
    },
    priority: 9,
  },
  url: {
    component: Url,
    options: {
      unfurl: {
        type: "boolean",
        default: false,
      },
    },
    priority: 1,
  },
  time: {
    component: TextLabel,
    options: {
      hideKeys: {
        type: "boolean",
        default: false,
      },
      display: {
        type: "string",
        default: "digital", // analog, digital
      },
    },
    priority: 1,
  },
  address: {
    component: TextLabel,
    options: {
      hideKeys: {
        type: "boolean",
        default: false,
      },
      map: {
        type: "boolean",
        default: false,
      },
      editable: {
        type: "boolean",
        default: false,
      },
    },
    priority: 1,
  },
  categories: {
    component: () => <></>,
    options: {
      hideKeys: {
        type: "boolean",
        default: true,
      },
      editable: {
        type: "boolean",
        default: false,
      },
      multiple: {
        type: "boolean",
        default: true,
      },
    },
    priority: 1,
  },
};

// prettier-ignore
const renderingHash = {
  shortText: {
    privateIdentifier: { widget: "hidden" },
    publicIdentifier: { widget: "heading" },
    display: { widget: "textLabel" },
  },
  paragraph: {
    privateIdentifier: { widget: "hidden" },
    publicIdentifier: { widget: "heading" },
    display: { widget: "text" },
  },
  number: {
    privateIdentifier: { widget: "hidden" },
    publicIdentifier: { widget: "heading", options: { hideKeys: false } },
    display: { widget: "textLabel", options: { color: "#008bbd", fontWeight: "600" } },
  },
  url: {
    privateIdentifier: { widget: "hidden" },
    publicIdentifier: { widget: "heading" },
    display: { widget: "url" },
  },
  time: {
    privateIdentifier: { widget: "hidden" },
    publicIdentifier: { widget: "heading", /* options: { hideKeys: false } */ },
    display: { widget: "time" },
  },
  location: {
    privateIdentifier: { widget: "hidden" },
    publicIdentifier: { widget: "heading", options: { hideKeys: false } },
    display: { widget: "address", editable: { widget: "address", options: { map: true, editable: true } } },
  },
  category: {
    privateIdentifier: { widget: "hidden" },
    publicIdentifier: { widget: "heading",  editable: {widget: "categories", priority: 8} },
    display: { widget: "textLabel", editable: { widget: "categories", options: { hideKeys: false, editable: true } } },
  },
}

/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */

const getWidgetDefaultOptions = (widgetName) => {
  const widget = widgets[widgetName];
  return Object.keys(widget.options).reduce((acc, key) => {
    acc[key] = widget.options[key].default;
    return acc;
  }, {});
};

export const getWidgetSetup = (
  schema,
  // options
  { isPrimary, isPreviewValue } = {
    isPrimary: false,
    isPreviewValue: false,
  }
) => {
  if (!schema) {
    throw new Error("No schema provided");
  }

  const functionTag = isPreviewValue
    ? "display"
    : isPrimary
      ? "publicIdentifier"
      : schema.function;

  let hash = renderingHash[schema.render][functionTag];
  if (schema.editable && hash.editable) hash = hash.editable;

  const options = {
    ...getWidgetDefaultOptions(hash.widget),
    ...hash.options,
  };

  const Component = widgets[hash.widget].component;

  return {
    render: (key, props) => {
      return <Component key={key} {...props} rendererOptions={options} />;
    },
    isPrimary: isPrimary || schema.function === "publicIdentifier",
    name: hash.widget,
    options: options,
  };
};
